import { Link } from "react-router-dom";
import { categoryTiles } from "@/mocks/categories";

export default function CategoryTiles() {
  return (
    <section className="mx-auto w-full max-w-[1360px] px-4 py-12 md:px-8 md:py-16">
      <div className="mb-7">
        <div className="flex items-center gap-2">
          <span className="h-3 w-[3px] rounded-full bg-accent-500"></span>
          <span className="font-label text-[11px] uppercase tracking-[0.28em] text-accent-500">
            Browse by category
          </span>
        </div>
        <h2 className="mt-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          按分类快速进入
        </h2>
        <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-500">
          四个常用入口，覆盖新片、经典与热度榜单，也可以按年份逐年回溯。
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {categoryTiles.map((tile) => (
          <Link
            key={tile.key}
            to={tile.to}
            className="group relative flex h-44 flex-col justify-end overflow-hidden rounded-lg border border-background-200/80 p-5 md:h-48"
          >
            <img
              src={tile.image}
              alt={`${tile.title} 分类封面`}
              title={`${tile.title} 韩国影视作品`}
              className="absolute inset-0 h-full w-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/70 to-background-50/10"></div>
            <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-accent-500/50 to-transparent opacity-0 transition-opacity group-hover:opacity-100"></div>

            <div className="relative">
              <div className="flex items-center justify-between">
                <span className="font-label text-[10px] uppercase tracking-[0.28em] text-accent-400">
                  {tile.english}
                </span>
                <span className="text-[11px] text-foreground-500">{tile.count}</span>
              </div>
              <h3 className="mt-1.5 font-heading text-lg font-bold text-foreground-950">
                {tile.title}
              </h3>
              <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-500">
                {tile.desc}
              </p>
              <span className="mt-3 inline-flex items-center gap-1 text-xs text-foreground-600 transition-colors group-hover:text-accent-400">
                进入分类
                <i className="ri-arrow-right-line text-xs transition-transform group-hover:translate-x-0.5"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}